import {
  Alert,
  Box,
  Button,
  ContentLayout,
  Header,
  Spinner,
} from '@cloudscape-design/components';
import { OrderTypes } from '@parallel-fluidics/shared/constants';
import { useQuery } from '@tanstack/react-query';
import fetchReorderOrderInitData from 'features/inventory/apis/fetchReorderOrderInitData';
import { useUserData } from 'providers/userDataProvider';
import React, { useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { ManageOrder } from '../../components/Orders';

export default function CreateOrderPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useUserData();
  const reorderSuggestionId = searchParams.get('reorderSuggestionId');
  const isInternal = searchParams.get('type') === OrderTypes.INTERNAL || !!reorderSuggestionId;
  const {
    data: reorderInitData,
    isLoading: isReorderLoading,
    error: reorderError,
  } = useQuery({
    queryKey: ['createOrderFromReorderSuggestion', reorderSuggestionId, user?.id],
    queryFn: () => fetchReorderOrderInitData(reorderSuggestionId, user.id),
    enabled: !!reorderSuggestionId && !!user?.id,
  });

  const initData = useMemo(() => reorderInitData || undefined, [reorderInitData]);

  return (
    <ContentLayout
      header={(
        <Header
          actions={<Button variant="normal" onClick={() => { navigate(`/orders?${searchParams.toString()}`); }}>See all orders</Button>}
        >
          {isInternal ? 'Create Internal Order' : 'Create Customer Order'}
        </Header>
      )}
    >
      {isReorderLoading && (
        <Box textAlign="center" padding="l">
          <Spinner size="large" />
        </Box>
      )}
      {reorderError && (
        <Alert type="error" header="Unable to create order from reorder suggestion">
          {reorderError.message}
        </Alert>
      )}
      {!isReorderLoading && !reorderError && (
        <ManageOrder initData={initData} />
      )}
    </ContentLayout>
  );
}
